import Place_Minimal from './Place_Minimal'
import Place_Documents from './Place_Documents'

export default {
    Place_Minimal,
    Place_Documents,
}
